module.exports = __webpack_public_path__ + "img/constec_black.c3d9472b.svg";